import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const getCustomer = async (customerId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/customers/${customerId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching customer:",
      error.response?.data || error.message
    );

    return {
      id: customerId,
      name: `Patient ${customerId}`,
      gender: null,
      dob: null,
    };
  }
};
